<script setup lang="ts">
type TItems = {
	icon: string;
	txt: string;
	link?: string;
};

defineProps<{
	title?: string;
	items: TItems[];
	price: string;
	price_txt: string[];
}>();
</script>
<template>
	<div class="bottom-details">
		<div class="wrapp-content">
			<div v-if="title" class="title">{{ title }}</div>
			<div v-for="(item, index) in items" :key="index" class="item">
				<div class="img-wrapp"><img :src="item.icon" alt="" /></div>
				<a v-if="item.link" :href="item.link" target="_blank">{{ item.txt }}</a>
				<span v-else>{{ item.txt }}</span>
			</div>
			<div class="price-data">
				<div class="price">{{ price }}</div>
				<div v-for="(txt, index) in price_txt" :key="index" class="price-txt">
					{{ txt }}
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.bottom-details {
	// background: #0d1015;
	box-sizing: border-box;
	width: 100%;
	min-height: 609px;
	// border-top-left-radius: 32px;
	// border-top-right-radius: 32px;
	padding-top: 122px;
	padding-bottom: 137px;
	font-family: Archivo, sans-serif;
	.wrapp-content {
		width: 100%;
		max-width: 1142px;
		margin: auto;
	}

	.title {
		color: #53aa6c;
		font-weight: 700;
		font-size: 54px;
		line-height: 100%;
		letter-spacing: 0%;
		text-align: center;
		margin-bottom: 80px;
	}
	.item {
		font-weight: 400;
		font-size: 20px;
		line-height: 120%;
		letter-spacing: 0%;
		display: flex;
		margin-bottom: 26px;
		color: #0a1a24;
		a {
			color: #0a1a24;
		}
		.img-wrapp {
			min-width: 48px;
		}
	}
	.item:last-of-type {
		margin-bottom: 0;
	}

	.price-data {
		margin-top: 64px;

		.price {
			font-weight: 700;
			font-size: 40px;
			line-height: 100%;
			letter-spacing: 0%;
			text-align: center;
			color: #53aa6c;
			margin-bottom: 28px;
		}
		.price-txt {
			font-weight: 400;
			font-size: 20px;
			line-height: 100%;
			letter-spacing: 0%;
			text-align: center;
			color: #000;
			margin-bottom: 8px;
		}
	}
}

@media screen and (width <= 768px) {
	.bottom-details {
		padding-top: 32px;
		padding-bottom: 137px;
		min-height: fit-content;

		.wrapp-content {
			width: calc(100% - 32px);
			margin: 0 16px;
		}

		.title {
			font-weight: 700;
			font-size: 24px;
			line-height: 100%;
			letter-spacing: 0%;
			text-align: left;
			margin-bottom: 16px;
		}
		.item {
			font-weight: 400;
			font-size: 16px;
			height: fit-content;

			.img-wrapp {
				min-width: 24px;
				width: 24px;
				img {
					width: 16px;
				}
			}
		}
		.item:last-of-type {
			margin-bottom: 0;
		}

		.price-data {
			margin-top: 32px;

			.price {
				font-size: 24px;
				margin-bottom: 8px;
			}
			.price-txt {
				font-weight: 400;
				font-size: 16px;
				margin-bottom: 8px;
			}
		}
	}
}
</style>
